import React, { useContext } from "react";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../../infrastructure/translation-manager";
import { TranslationKeys } from "../../../infrastructure/const";
import IStaticContentContext from "../../../infrastructure/context/static-content/static-content.context.interface";
import StaticContentContext from "../../../infrastructure/context/static-content/static-content.context";

const LandingPageSimpleWelcomeBanner = (): JSX.Element | null => {
  const context = useContext<ITranslationsContext>(TranslationsContext);
  const configurationContext =
    useContext<IStaticContentContext>(StaticContentContext);

  const translationManager = new TranslationManager(context);

  const { imageUrl } = configurationContext.introBanner || {};

  const inlineStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};

  return (
    <div className="welcome-banner">
      <div className="welcome-banner__img" style={inlineStyle}></div>

      <div className="welcome-banner__wrapper">
        <h1 className="welcome-banner__heading">
          {translationManager.getTranslation(
            TranslationKeys.LANDINGPAGE_WELCOMEMESSAGE
          )}
        </h1>
      </div>
    </div>
  );
};

export default LandingPageSimpleWelcomeBanner;
